export default "__VITE_ASSET__CApdIeyE__"